import { gql } from '@apollo/client';

export const getInviteGql = gql`
  query invite($inviteCode: String!) {
    getInvite (inviteCode: $inviteCode)
      @rest(type: "Invite", path: "invites/{args.inviteCode}") {
        id
        title
        forename  
        name
        email
        company
        seat
        seatTableId
        status
        customAttributes
        maxCustomerCount
        usedCount
        waitingList
        groupStrings
        attendees {
          id
          title
          forename
          name
          email
          ticketDownloadUrl
          alreadyUsed
          customAttributes
          eventTableId
          seat
          waitingList
          companionId
          ticketCategory {
            id
            name
          }
        }
        inviteCategory {
          maxCustomerCount
          name
        }
        inviteForm {
          name
          title
          type
          description
          successDescription
          status
          frontendSettings
          elements {
            id
            type
            title
            description
            promptBy
            params
          }
        }
        eventTable
        eventTables
        quotas
    }
  }
`;

export const getInviteFormGql = gql`
  query invite($formInviteId: String!) {
    getInviteForm (formInviteId: $formInviteId)
      @rest(type: "InviteForm", path: "external/inviteForms/{args.formInviteId}") {
        name
        title
        description
        successDescription
        status
        elements {
          id
          type
          title
          description
          promptBy
          params
        }
    }
  }
`;

export const getInviteFormByPathGql = gql`
  query inviteFormByPath($path: String!) {
    getInviteFormByPath (path: $path)
      @rest(type: "InviteForm", path: "inviteFormsByPath/{args.path}") {
        inviteForm {
          title
          type
          description
          successDescription
          elements {
            id
            type
            title
            description
            promptBy
            params
          }
          attributes
          frontendSettings
        }
        logoUrl
        colors
        font {
          regular {
            name
            font
          }
          bold {
            name
            font
          }
        }
        customCss
        themeConfig
        attributeQuotas
        isBookedOut
      }
  }
`;

export const createInviteGql = gql`
  mutation createInvite($path: String!, $input: PublishablePostInput!) {
    createInvite (path: $path,  input: $input) @rest(
      path: "inviteFormsByPath/{args.path}/invites",
      method: "POST"
    ) {
      token
    }
  }
`;

export const updateInviteGql = gql`
  mutation updateInvite($inviteCode: String!, $input: PublishablePostInput!) {
    createInvite (inviteCode: $inviteCode,  input: $input) @rest(
      path: "invites/{args.inviteCode}",
      method: "POST"
    ) { NoResponse }
  }
`;

export const sendInviteProgressGql = gql`
  mutation sendInviteProgress($inviteCode: String!, $input: PublishablePostInput!) {
    sendInviteProgress(inviteCode: $inviteCode, input: $input) @rest(
      path: "invites/{args.inviteCode}/progress",
      method: "POST"
    ) {
      NoResponse
    }
  }
`;
